import { DateInput } from "@mantine/dates";
import { tu } from "beitary-shared";
import { ReactNode } from "react";

export interface BDateInputProps {
  required?: boolean;
  onChange?: (value: number | undefined) => void;
  error?: ReactNode;
  value?: number;
  minDateTime?: number;
  maxDateTime?: number;
  disabled?: boolean;
  label?: string;
}

export const BDateInput = ({
  minDateTime,
  maxDateTime,
  ...props
}: BDateInputProps) => {
  const getDate = (v?: number) => {
    if (v === undefined) return undefined;
    return tu.getDate(v);
  };

  const getEpoch = (d: Date | null) => {
    if (!d) return undefined;
    return tu.getDateTime(d);
  };

  // TODO need to create date input??
  return (
    <DateInput
      {...props}
      popoverProps={{ withinPortal: true }}
      minDate={getDate(minDateTime)}
      maxDate={getDate(maxDateTime)}
      // icon={<IconCalendar stroke={1.5} />}
      value={getDate(props.value)}
      onChange={(v) => {
        props.onChange && props.onChange(getEpoch(v));
      }}
    />
  );
};
